/* eslint-disable array-callback-return */
import { useState, useRef, useEffect } from "react"
import { useContext } from "react"
import { GpraContext } from "../../../../../context/gpraContext"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import {
  showQuestion,
  updateState,
  showMessage,
  getAdditionalQuestions,
  validateQuestions,
  existsErrors,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  nextForm,
} from "../../../utils/utils"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import FormLabel from "../../../Common/FormLabel"
import { Dropdown } from "primereact/dropdown"
import { confirmation } from "../../../types/dropDownTypes"
import FormError from "../../../Common/FormError"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { Fieldset } from "primereact/fieldset"
import { errorMessages } from "../../../types/messages"
import { Calendar } from "primereact/calendar"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import { UserContext } from "../../../../../context/userContext"
import { useQuery } from "@apollo/client"
import { GET_USER } from "../../../../User/queries"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"

const Start = ({ showToolBar, disabled }) => {
  const {
    interviewType,
    interview,
    questions,
    updateInterviewValues,
    handleSubmitPut,
    handleSectionsCompleted,
    sectionsCompleted,
    additionalQuestions,
    setAdministrativeInterview,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [start, setStart] = useState(interview[INTERVIEW_SECTIONS.RECORD_MGMT])
  const [validationErrors, setValidationErrors] = useState({})
  const [staffUser, setStaffUser] = useState()
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef()

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.START_INTERVIEW &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.START_INTERVIEW
        )
      }

      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validationForm = () => {
    const errors = {}
    if (
      start?.gpra_interview_conducted === undefined &&
      showQuestion(questions, "gpra_interview_conducted")
    ) {
      errors.gpra_interview_conducted = errorMessages.requiredMessage
    }
    if (
      !start.gpra_interview_date &&
      start.gpra_interview_conducted &&
      showQuestion(questions, "gpra_interview_date")
    ) {
      errors.gpra_interview_date = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        start,
        INTERVIEW_SECTIONS.START_INTERVIEW,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  useQuery(GET_USER, {
    variables: { staff_id: userCtx.session.user.staff_id },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setStaffUser(data)
    },
  })

  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.RECORD_MGMT, start)
    if (!prevForm) {
      if (validationForm()) {
        handleSubmitPut(endpoints.START_INTERVIEW, {
          gpra_organization_uuid: userCtx.session.user.organization_id,
          gpra_participation_consent: true,
          gpra_interview_type: interviewType,
          gpra_client_type:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_client_type,
          gpra_staff_uuid: userCtx.session.user.staff_id,
          gpra_staff_id: interview[INTERVIEW_SECTIONS.RECORD_MGMT].staff_alias,
          date_start:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_interview_date,
          gpra_participant_uuid: userCtx.participant_id,
          gpra_membership_uuid: userCtx.participant_membership_id,
          gpra_staff_email: staffUser?.user?.staff_email_address,
          additional: getAdditionalQuestions(start),
          administrative_interview:
            !interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_interview_conducted,
        }).then((response) => {
          if (response.status === 200 || response.status === 201) {
            updateInterviewValues(INTERVIEW_SECTIONS.RECORD_MGMT, {
              ...start,
              staff_id: response?.data?.gpraStaffUuid,
            })
            setNextForm(
              nextForm(sections, activeIndex, administrativeInterview)
            )
            setNavigationItem()
            handleSectionsCompleted({
              ...sectionsCompleted,
              ...{ startInterview: true },
            })
          }
        })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }
  const renderDefaultMain = (question) => {
    if (question.field === "gpra_interview_conducted") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`Did you conduct a ${
              interviewType === "FollowUp" ? "follow-up" : "discharge"
            } interview?`}
            required
          />
          <Dropdown
            className={
              validationErrors.gpra_interview_conducted
                ? gpraStyles.input3Error
                : gpraStyles.input3
            }
            value={start.gpra_interview_conducted}
            onChange={(e) => {
              updateState(
                "gpra_interview_conducted",
                e.value,
                null,
                null,
                start,
                setStart
              )
              removeError("gpra_interview_conducted")
              setAdministrativeInterview(e.value)
            }}
            options={confirmation}
            optionLabel="label"
            optionValue="value"
            showClear={start.gpra_interview_conducted}
            disabled={disabled || editMode}
          />
          <FormError error={validationErrors.gpra_interview_conducted} />
        </div>
      )
    }
    if (question.field === "gpra_interview_date") {
      if (start.gpra_interview_conducted) {
        const availDate = new Date(interview?.recordManagement?.gpra_avail_date)
        availDate.setUTCSeconds(availDate.getSeconds() + 1)
        return (
          <div className={gpraStyles.formRow}>
            <FormLabel label={"Interview Date"} required/>
            <Calendar
              disabled={disabled}
              className={
                validationErrors.interviewDate
                  ? gpraStyles.calendarError
                  : gpraStyles.calendar
              }
              showIcon
              showButtonBar
              monthNavigator
              yearNavigator
              yearRange={`1900:${new Date().getFullYear()}`}
              minDate={availDate}
              value={start.gpra_interview_date}
              onChange={(e) => {
                updateState(
                  "gpra_interview_date",
                  e.value,
                  null,
                  null,
                  start,
                  setStart
                )
                removeError("gpra_interview_date")
              }}
              maxDate={new Date()}
            />
            <FormError error={validationErrors.interviewDate} />
          </div>
        )
      }
    }
  }
  return (
    <>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              nextForm={true}
              saveData={saveData}
              toast={toast}
              showCancel={false}
              prevForm={false}
            />
          }
        ></Toolbar>
      )}
      <Fieldset legend="A. START INTERVIEW" style={{ marginBottom: "1rem" }}>
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={start}
                    setEntity={setStart}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.START_INTERVIEW}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, start)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={start}
                      setEntity={setStart}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.START_INTERVIEW}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </>
  )
}
export default Start
Start.defaultProps = {
  showToolBar: true,
  disabled: false,
}
